/** @format */

// 加载React
// 加载Component
import React, { Component } from 'react';
// 路由对象
import { withRouter } from 'react-router-dom';
// Cookie对象
import Cookie from 'js-cookie';
// 引入antd的组件
import { Badge, Dropdown, Form, Menu, message, Select } from 'antd';
// 站点配置
import config from 'config/Config';
// 加载当前组件样式
import styles from './HeaderBarLess.less';
// 引入组织机构组件
// 引入我的消息组件
// 引入修改密码对话框
// 样式管理
import cx from 'classnames';
// Cookie localStorage等的存储管理
import { clearCookie } from 'utils/store';

import { YxAction, YxModal, YxText, YxDynamicForm, YxPanel } from 'yx-widget';

import CubeI8N from 'utils/cubeI8N';
import Serv from './HeaderBarServ'
import { map, get, every } from 'lodash'
import { rstr2b64 } from 'utils/md5';
import HeaderNavView from 'widget/HeaderNav/HeaderNavView';
import HeaderGlobalView from 'widget/HeaderGlobal/HeaderGlobalView';
import YxDropMenu from '../../pages/Component/YxDropMenu'
import { inject, observer } from 'mobx-react';
const IconFont = YxText.Icon;
const Option = Select.Option;
const { SubMenu } = Menu;
// 静态资源CDN前缀
const CDN_BASE = config.CDN_BASE || '';

// 是否已加载成功
let loadedSuccess = false;

@withRouter
@inject('HeaderNavMod', 'HeaderBarMod', 'AppStore')
@observer
// 导出组件
class HeaderBar extends Component {
  // 构造函数
  constructor(props, context) {
    super(props, context);
    this.state = {
      isActive: false, // 下拉面板
      modalVisible: false,
      userName: '',
      userInfo: {},
      selectedColor: '',
      selectedItem: '',
    };
    this.CubeI8NgetStging = new CubeI8N().getString;
  }

  // 已插入DOM
  async componentDidMount() {
    let self = this;
    loadedSuccess = true;
    const res = await Serv.getUser()
    this.setState({ userInfo: get(res, 'data', {}) })
    let userName = ''
    if (get(res, 'data.userName', '')) {
      userName = get(res, 'data.userName', '')
    } else {
      userName = Cookie.get(config.cookie.user_name)
    }
    this.setState({ userName })
    Cookie.set(config.cookie.user_name, userName)
  }
  componentWillMount() {
    const { HeaderBarMod: store } = this.props;
    // 多语言实例化
    this.CubeI8N = new CubeI8N();
    this.props.HeaderNavMod.appInsName = '请选择应用切换';
    if (localStorage.getItem('roleCode') == 'BOCMANAGER') {
      store.getMessageCount()
    } else {
      this.props.HeaderNavMod.getAppList({ tenantId: Cookie.get("tenant_id"), filter: {}, userId: Cookie.get('user_id') }).then(res => {
        let arr = [];
        map(res.data, (item, index) => {
          if (item.isRelated == 1 && item.id !== 1) {
            arr.push(item)
          }
        })
        if (arr.length == '1') {
          this.setState({ isOnlyOne: true })
        }
        const headerNavBoc = localStorage.getItem('headerNavBoc') ? JSON.parse(localStorage.getItem('headerNavBoc')) : '';
        if (every(arr, item => item.code != 'BOC') && headerNavBoc) {
          arr.unshift(headerNavBoc);
        }
        map(arr, item => {
          item.text = item.appInsName
          item.value = item.id
          item.extra = <img className="appImg" src={item.logoUrl || `assets/imgs/AppIcon/dataReview.png`} />
        })
        this.props.HeaderNavMod.setAppList(arr);
        if (this.props.history.location.pathname == '/productDetail' || this.props.history.location.pathname == '/ProductDetail') {
          this.props.HeaderNavMod.setAppInsName(Cookie.get('childrenAppInsName'))
        }
      })
    }
  }

  // 执行退出
  async doLogout() {
    const { HeaderBarMod: store, AppStore: appStore } = this.props;
    let self = this;
    // // 注销登录
    // let { resultCode, resultMsg } = await  delCacheUser({})
    let { resultCode, resultMsg } = await store.logout()
    if ('0' !== '' + resultCode) {
      message(resultMsg || '注销失败', 'error')
      return false
    }
    appStore.sendMessage({ eventKey: 'bocLogout', dataSource: {} })
    // 清除Cookie
    clearCookie();
    // 注销成功提示
    // 跳转到登录页
    //定时器为了通知到子项目
    setTimeout(() => {
      message.success('注销成功');
      this.props.history.push('/login');
    })
  }


  // 下拉菜单点击事件
  handleClickMenu(e) {
    let self = this;
    // 点击那一项
    switch ('' + e.key) {
      case 'logout':
        // 退出登录
        self.doLogout();
        break;
      case 'forgetPassword':
        this.setState({ modalVisible: true });
        break;
      case 'yellow':
        self.handleClick('yellow');
        localStorage.setItem('boc_themes', 'yellow');
        break;
      case 'blue':
        self.handleClick('blue');
        localStorage.setItem('boc_themes', 'blue');
        break;
      default:
        console.log('unknown key');
    }
  }

  // 点击用户登录信息的下拉菜单
  getDropDownMenu() {
    return (
      <Menu style={{ zIndex: 9999 }} onClick={e => this.handleClickMenu(e)}>
        <Menu.Item key="forgetPassword">
          <a>修改密码</a>
        </Menu.Item>
        <Menu.Item key='logout'>
          <a>注销</a>
        </Menu.Item>
        <SubMenu title="换肤">
          <Menu.Item key='blue'>蓝色</Menu.Item>
          <Menu.Item key='yellow'>黄色</Menu.Item>
        </SubMenu>
      </Menu>
    );
  }

  // 渲染用户信息
  renderUserInfo() {
    let param = {
      text: <span>{this.state.userName}</span>,
      extra: <img className={`avtar`} src={`assets/imgs/avtar.jpg`} />,
      content: this.getMenuList(),
      inputParam: {
        placement: 'bottomRight',
        trigger: ['click'],
      },
    }
    return (
      <div className={styles.user}>
        <YxDropMenu {...param}></YxDropMenu>
      </div>
    );
  }
  changeStyle(color) {
    let { selectedColor } = this.state;
    if (selectedColor !== color) {
      this.handleClick(color);
      localStorage.setItem('boc_themes', color);
      this.setState({ selectedColor: color })
    }
  }
  getSelectStyle() {
    return <div className={`inneritem-container`}>
      <div className="inneritem-left"></div>
      <div className="inneritem-right"></div>
    </div>
  }
  getMenuList() {
    let arr = ['item1']
    let colorList = [
      { key: 'item1', color: 'blue' },
      { key: 'item3', color: 'yellow' },
    ]
    let { selectedColor } = this.state;
    let param = {
      header: "换肤",
      disabled: false,
      showArrow: false,
      change: () => {
        this.state.isActive = !this.state.isActive;
        this.forceUpdate();
      },
      extra: <div>
        <IconFont type="iconshanglashouqi" className={`${this.state.isActive ? 'hideIcon' : ''}`} iconfont={true}></IconFont>
        <IconFont type="iconxialazhanshi" className={`${this.state.isActive ? '' : 'hideIcon'}`} iconfont={true}></IconFont>
      </div>,
      bordered: true,
      children: <div>
        {arr.map((item) => {
          return <div className={'childrenItem'}>
            {colorList.map((innerItem) => {
              return <div className={`color-item color-item-${innerItem.color}`} onClick={() => { this.changeStyle(innerItem.color) }}>
                {selectedColor == innerItem.color ? this.getSelectStyle() : ''}
              </div>
            })}
          </div>
        })}
      </div>,
    }
    let menuList = <Menu className={`yx-dropdown-default-style yx-menu-top istop`}>
      <Menu.Item key="logout">
        <span className={'menu-text-item'} onClick={() => this.doLogout()}>注销</span>
      </Menu.Item>
      <Menu.Item key="logout">
        <span className={'menu-text-item'} onClick={() => { this.setState({ modalVisible: true }); }}>修改密码</span>
      </Menu.Item>
      <Menu.Item key="select">
        <YxPanel {...param}>
        </YxPanel>
      </Menu.Item>
    </Menu>
    return menuList
  }
  handleClick = (value) => {
    const linkMap = {
      'yellow': 'assets/css/yellow_app.css',
      'blue': 'app.css'
    }
    let a = document.getElementsByTagName('head')[0].getElementsByTagName('link');
    for (let i = 0; i < a.length; i++) {
      let elm = a[i];
      if (elm.href.indexOf("app.css") > -1) {
        elm.href = linkMap[value];
      }
    }
  }

  getFormParam = () => {
    const colList = [
      {
        controlList: [
          {
            type: 'Password',
            controlItemParam: {
              id: 'password',
              label: '原密码',
              strength: null,
              defaultValue: '',
              placeholder: '请输入原密码',
              rules: map([
                { required: true, message: '请输入新密码' },
              ], item => {
                return { ...item, message: decodeURI(item.message) }
              }),
              styleParam: {
                width: 'xl'
              }
            }
          },
          {
            type: 'Password',
            controlItemParam: {
              id: 'password1',
              label: '新密码',
              // strength: config.PASSWORD_RULE ? null : 'lv2',
              defaultValue: '',
              placeholder: config.PASSWORD_RULE_PLACEHOLDER || '请输入新密码',
              // rules: map(config.PASSWORD_RULE || [
              //   { required: true, message: '密码必须为大小写字母，数字，特殊符号中的三种，长度8位或以上' },
              // ], item => {
              //   console.log('item: ', item);
              //   return { ...item, message: decodeURI(item.message) }
              // }),
              rules: {
                required: true,
                pattern: {
                  pattern: config.PASSWORD_RULE,
                  message: '密码必须为大小写字母，数字，特殊符号中的三种，长度8位或以上'
                }
              },
              styleParam: {
                width: 'xl'
              }
            }
          },
          {
            type: 'Password',
            controlItemParam: {
              id: 'password2',
              isContrastId: 'password1',
              label: '确认密码',
              defaultValue: '',
              // strength: config.PASSWORD_RULE ? null : 'lv2',
              placeholder: config.PASSWORD_RULE_PLACEHOLDER || '请输入确认密码',
              // rules: map(config.PASSWORD_RULE || [
              //   { required: true, message: '两次密码输入密码不一致，请重试' },
              // ], item => {
              //   return { ...item, message: decodeURI(item.message) }
              // }),
              rules: {
                required: true,
                pattern: {
                  pattern: config.PASSWORD_RULE,
                  message: '两次密码输入密码不一致，请重试'
                }
              },
              styleParam: {
                width: 'xl'
              }
            }
          }
        ]
      },
    ];

    const row = map(colList, item => {
      return {
        col: [item]
      };
    });
    return {
      form: [
        {
          row
        }
      ]
    };
  };

  handleOk = async () => {
    const res = await this.props.form.validateFieldsAndScroll();
    if (res.error) {
      return;
    }
    const data = {
      userName: Cookie.get(config.cookie.user_name),
      password: config.isMd5Password ? rstr2b64(res.password) : res.password,
      newPassword: config.isMd5Password ? rstr2b64(res.password1) : res.password1,
      instanceId: '1254039287584232622',
      tenantId: '1'
    };
    if (this.state.userInfo['userName##mix##'] || this.state.userInfo['userName##cipher##']) {
      data.userName = this.state.userInfo['userName']
      data['userName##mix##'] = this.state.userInfo['userName##mix##']
      data['userName##cipher##'] = this.state.userInfo['userName##cipher##']
    }
    const res2 = await Serv.updatePwd({ data })
    if (res2 && res2.resultCode + '' === '0') {
      message.success('修改密码成功');
      this.setState({ modalVisible: false });
    }
  };

  handleChangeOrg = (orgId) => {
    this.props.changeOrg(orgId)
  }

  getMenu() {
    let { selectedItem } = this.state;
    let content = (<Menu className={`yx-dropdown-flex-style yx-menu-top`}>
      { this.props.HeaderNavMod.appList.map((inneritem) => {
        return <Menu.Item key={inneritem.id} className={`${selectedItem == inneritem.id ? 'yx-dropdown-select-item' : ''}`}>
          <div className={`appItem`} onClick={() => this.props.HeaderNavMod.appChange({ item: inneritem, AppStore: this.props.AppStore, history: this.props.history })}>
            {inneritem.extra}
            <span>{inneritem.text}</span>
          </div>
        </Menu.Item>
      })}
    </Menu>)
    return content
  }

  // 渲染内容
  render() {
    const collapsed = this.props.collapsed;
    const { style, className, prefix = 'Header', history, HeaderBarMod: store } = this.props;
    const pathname = history.location.pathname;
    const isProductList =
      pathname == '/productList' ||
      pathname == '/ProductList' ||
      (localStorage.getItem('roleCode') != 'BOCMANAGER' && pathname == '/');
    const wrapCls = isProductList ? `${styles.Header} f-row` : `${styles.Header1} f-row`
    const appLogoImg = localStorage.getItem('roleCode') == 'BOCMANAGER' ? (config.logoImg || `assets/imgs/logo.png`) : (Cookie.get('childrenAppLogo') || config.logoImg || `assets/imgs/logo.png`)
    const modalParam = {
      width: 700,
      title: '修改密码',
      visible: this.state.modalVisible,
      destroyOnClose: true,
      maskClosable: false,
      wrapClassName: styles.modal,
      onCancel: () => {
        this.setState({ modalVisible: false });
      },
      onOk: this.handleOk
    };
    let param = {
      extra: <IconFont type={`icontb_chanpinyingyong`} size={'sm'} className={'app-icon'} iconfont={true}></IconFont>,
      text: <span>{this.CubeI8NgetStging('header.application', '应用')}</span>,
      content: this.getMenu(),
      isClickClose: true, // 是否选中菜单关闭菜单弹窗
      inputParam: {
        placement: 'bottomRight',
        trigger: ['click'],
      },
    }
    return (
      <div className={wrapCls}>
        {/* 弹出的修改密码对话框 - 默认隐藏 */}
        <YxModal {...modalParam}>
          <YxDynamicForm form={this.props.form} formParam={this.getFormParam()} />
        </YxModal>
        {isProductList ? (
          <div className={styles.tophead + ' f-grow-1 f-row'}></div>
        ) : (
          <div className={styles.tophead}>
            <div className={cx(styles.logo, collapsed ? styles.headerLogoCollapsed : '')}>
              {collapsed ? (
                <img src={appLogoImg} />
              ) : (
                <div className={styles.logoText}>
                  <img src={appLogoImg} />
                  <span className={styles.spanText}>{config.applicationName || this.CubeI8N.getString(config.appName, '泰啤运营平台')}</span>
                  <IconFont
                    className={styles.envIcon}
                    iconfont={true}
                    type={config.envIcon || `iconjichengbiaoqian`}
                  ></IconFont>

                </div>
              )}
            </div>
            {/* 左侧header */}
            <div className={styles.headeCont} style={{ width: '100%' }}>
              {localStorage.getItem('roleCode') == 'BOCMANAGER' ? ''
                : (
                  <div className='f-row f-ai-center' style={{ height: '100%', width: '100%' }}>
                    {/* 公共头部 */}
                    <HeaderGlobalView className='f-grow-1' style={{ marginLeft: 50, padding: '0 20px' }} />
                  </div>
                )}
            </div>
          </div>
        )}
        {/* 右侧header */}
        <div className={styles.headRight} id='routerApp_headRight'>
          <div className={cx(styles.table, styles.right)}>
            <div className={styles.row}>
              {localStorage.getItem('roleCode') == 'BOCMANAGER' ?
                <div onClick={e => this.props.history.push('/myMessage')} className={`${styles.cell} ${styles.yxmessage} ${styles.itemHover}`}>
                  <Badge count={store.messageCount || 0} style={{ backgroundColor: '#E61717' }}>
                    <IconFont type={`icontb_xitongxiaoxi`} className={styles.userMessageIcon} iconfont={true} ></IconFont>
                  </Badge>
                </div> : <div className={`${styles.yxDropDown} ${styles.appText}`}>
                  <YxDropMenu {...param}></YxDropMenu>
                </div>}

              <div className={`${styles.cell} ${styles.userInfo}`}>
                {this.renderUserInfo()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Form.create()(HeaderBar);



// WEBPACK FOOTER //
// ./src/widget/HeaderBar/HeaderBarView.js